import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-teacher-information',
  templateUrl: './teacher-information.component.html',
  styleUrls: ['./teacher-information.component.scss']
})
export class TeacherInformationComponent implements OnInit, OnDestroy {
  allTeachers: any[] = [];
  TeacherInfo: any[] = [];
  fetchinData = true;

  // Selected Main Category: 'school' | 'college' | 'all'
  selectedCategory: string = 'school';

  // Selected Sub Category:
  // School: 'all' | 'bangla-version' | 'english-version'
  // College: 'all' | 'science' | 'business-studies' | 'humanities'
  selectedSubCategory: string = 'all';

  private ngUnsubscribe = new Subject();

  constructor(private appService: AppService, private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.FetchTeacherInfo();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchTeacherInfo() {
    this.fetchinData = true;
    forkJoin([
      this.appService.getTeaherStaff(),
    ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      const allData = response[0].data || [];
      // Filter out office staff from all teachers
      this.allTeachers = allData.filter((x: any) => {
        const arena = (x.JobArena || x.jobArena || '').toString().trim().toLowerCase();
        return arena !== 'office' && arena !== 'staff';
      });
      this.applyFilter();
      this.fetchinData = false;
      this._changeDetectorRef.markForCheck();
    });
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.selectedSubCategory = 'all';
    this.applyFilter();
  }

  selectSubCategory(subCategory: string) {
    this.selectedSubCategory = subCategory;
    this.applyFilter();
  }

  applyFilter() {
    if (!this.allTeachers || this.allTeachers.length === 0) {
      this.TeacherInfo = [];
      return;
    }

    this.TeacherInfo = this.allTeachers.filter((item: any) => {
      const arena = (item.JobArena || item.jobArena || '').toString().toLowerCase().trim();
      const dept = (item.Department || item.department || '').toString().toLowerCase().trim();
      const sub = (item.Subject || item.subject || '').toString().toLowerCase().trim();
      const desig = (item.Designation || item.designation || '').toString().toLowerCase().trim();
      const version = (item.Version || item.version || '').toString().toLowerCase().trim();
      const group = (item.Group || item.group || '').toString().toLowerCase().trim();

      const combined = `${arena} ${dept} ${sub} ${desig} ${version} ${group}`;

      const isCollege = arena.includes('college') || arena.includes('collage');
      const isSchool = arena.includes('school') || arena.includes('bangla version') || arena.includes('english version');

      if (this.selectedCategory === 'school') {
        if (isCollege && !isSchool) {
          return false;
        }

        if (this.selectedSubCategory === 'bangla-version') {
          if (arena.includes('english version') || version.includes('english')) return false;
          return true;
        } else if (this.selectedSubCategory === 'english-version') {
          return arena.includes('english') || version.includes('english') || combined.includes('english');
        }
        return true;
      } 
      else if (this.selectedCategory === 'college') {
        if (isSchool && !isCollege) {
          return false;
        }

        if (this.selectedSubCategory === 'science') {
          return arena.includes('science') || dept.includes('science') || group.includes('science') || combined.includes('science') || combined.includes('physics') || combined.includes('chemistry') || combined.includes('biology') || combined.includes('math');
        } else if (this.selectedSubCategory === 'business-studies') {
          return arena.includes('business') || arena.includes('commerce') || dept.includes('business') || dept.includes('commerce') || group.includes('business') || group.includes('commerce') || combined.includes('accounting') || combined.includes('finance') || combined.includes('management') || combined.includes('business');
        } else if (this.selectedSubCategory === 'humanities') {
          return arena.includes('humanities') || arena.includes('arts') || dept.includes('humanities') || dept.includes('arts') || group.includes('humanities') || group.includes('arts') || combined.includes('history') || combined.includes('civics') || combined.includes('economics') || combined.includes('humanities');
        }
        return true;
      }

      return true;
    });
  }
}
